<div echarts [options]="option" class="funnel-chart" id="main"></div>